import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from "vuex-shared-mutations";
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [
    createMutationsSharer({
      predicate: [
        'SET_REFRESH_ACCOUNTS'
      ]
    })
  ],
  strict: process.env.NODE_ENV !== 'production'
})
